import React from 'react';
import PropTypes from 'prop-types';

import { Badge } from '@kajabi/sage-react';
import { PdsBox, PdsRow, PdsRadio } from '@pine-ds/react';

import useTranslatedPrice from '../../hooks/useTranslatedPrice';

const PricingBody = ({ option, isSelected, handleOptionChange }) => {
  const { getTranslatedPrice } = useTranslatedPrice();
  const { displayedPrice, setupFee, trialPeriod } = getTranslatedPrice(option.price);

  return (
    <PdsBox
      className="pricing-body"
      direction="column"
      padding="md"
      onClick={() => handleOptionChange(option)}
    >
      <PdsRow colGap="xxs">
        <PdsBox className="price-details" direction="row" justifyContent="space-between">
          <p className="description">{displayedPrice}</p>
          <PdsBox justifyContent="end" alignItems="start">
            {trialPeriod && (
              <div>
                <Badge value={trialPeriod} large={false} />
              </div>
            )}
            <PdsRadio name="offer-variant" value={option.id} checked={isSelected} />
          </PdsBox>
        </PdsBox>
      </PdsRow>
      {setupFee && (
        <PdsRow padding="md" direction="row" justifyContent="start">
          <p className="setup-fee">{setupFee}</p>
        </PdsRow>
      )}
    </PdsBox>
  );
};

const RecommendationHeader = () => (
  <PdsRow className="recommendation-header">
    <PdsBox justifyContent="end">Recommended</PdsBox>
  </PdsRow>
);

const PricingOption = ({ option, isSelected, handleOptionChange }) => {
  let cssClasses = 'embedded-checkout-pricing-option';

  if (isSelected) {
    cssClasses += ' selected';
  }

  if (option.isRecommended) {
    cssClasses += ' recommended';
  }

  return (
    <PdsBox key={option.id} className={cssClasses} direction="column" gap="none">
      {option.isRecommended && <RecommendationHeader />}
      <PricingBody
        option={option}
        isSelected={isSelected}
        handleOptionChange={handleOptionChange}
      />
    </PdsBox>
  );
};

const PricingOptionType = PropTypes.shape({
  id: PropTypes.number.isRequired,
  position: PropTypes.number.isRequired,
  isRecommended: PropTypes.bool,
  price: PropTypes.shape({
    amount: PropTypes.number.isRequired,
    currency: PropTypes.string.isRequired,
    exponent: PropTypes.number.isRequired,
    priceStrategy: PropTypes.string.isRequired,
    priceType: PropTypes.string.isRequired,
  }).isRequired,
  subscriptionPlanAttributes: PropTypes.shape({
    paymentType: PropTypes.string.isRequired,
    interval: PropTypes.string.isRequired,
    intervalCount: PropTypes.number.isRequired,
    numberOfPayments: PropTypes.number,
    trialPeriodDays: PropTypes.number,
    setupFee: PropTypes.number.isRequired,
    setupFeeTextOverride: PropTypes.string,
  }),
});

PricingOptionType.defaultProps = {
  isRecommended: false,
};

PricingBody.propTypes = {
  option: PricingOptionType.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleOptionChange: PropTypes.func.isRequired,
};

PricingOption.propTypes = {
  option: PricingOptionType.isRequired,
  isSelected: PropTypes.bool.isRequired,
  handleOptionChange: PropTypes.func,
};

PricingOption.defaultProps = {
  handleOptionChange: () => {},
};

export default PricingOption;
